import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleRentalPriceTabComponent } from './vehicle-rental-price-tab.component';
import {PriceTableModule} from "../shared/components/price-table/price-table.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {MatTableModule} from "@angular/material/table";
import {CardModule} from "../../../../../../ui_card/card.module";
import {PriceModule} from "../../../../../price/price.module";
import {StayPriceTabModule} from "../stay-price-tab/stay-price-tab.module";
import {CarTitleModule} from "../../../../../rental/car/car-title/car-title.module";



@NgModule({
  declarations: [VehicleRentalPriceTabComponent],
    imports: [
        CommonModule,
        PriceTableModule,
        FontAwesomeModule,
        MatTableModule,
        CardModule,
        PriceModule,
        StayPriceTabModule,
        CarTitleModule,
    ],
  exports: [
    VehicleRentalPriceTabComponent,
  ]
})
export class VehicleRentalPriceTabModule { }
